import { trackClick } from 'lib/api/track-click';
import { getGeoCountry } from 'lib/get-geo-country';
import { SupportedLanguage } from 'lib/lexemes/supported-languages';
import { startsWithSupportedPath } from 'lib/seo/seo';
import { setupLangAndUrlParams } from 'lib/set-url-params';
import { startsWithSupportedLanguage } from 'lib/supported-languages';
import { GetServerSidePropsContext } from 'next';

export type GetServerSidePropsType = GetServerSidePropsContext<{
  lang: SupportedLanguage;
}> & {
  locale?: SupportedLanguage;
};

export const getServerSideProps = async function ({
  query,
  locale,
  res,
  req,
}: GetServerSidePropsType) {
  /**
   * Temporary fix
   * trying to avoid too many unnessary requests
   */
  res.setHeader('Cache-Control', 'public, s-maxage=10, stale-while-revalidate=59');
  /**
   * we only use lang, slug from query
   * & lang in getLocale(undefined, query)
   */
  const { lang } = await setupLangAndUrlParams(query, locale);

  /** Return 404 */
  if (lang && !startsWithSupportedLanguage(`/${lang}`)) {
    return {
      notFound: true,
    };
  }

  /** Return 404 */
  if (query.slug && query.slug[0] && !startsWithSupportedPath(`/${query.slug[0]}`)) {
    return {
      notFound: true,
    };
  }

  /**
   * internal tracking: avoid tracking for pages: index, about, date, as it is done in monolith
   */
  if (
    (req && req.url?.startsWith(`/${lang}/global-dating-trends`)) ||
    (req && req.url?.startsWith('/global-dating-trends')) ||
    (req && req.url?.startsWith(`/${lang}/features`)) ||
    (req && req.url?.startsWith('/features'))
  ) {
    trackClick({
      req,
      lang,
    });
  }

  // Call getRecentPosts with appropriate parameters
  // const { posts, hasNextPage, total } = await getRecentPosts(POST_COUNT, null, null, null);

  return {
    props: {
      geoIpCountry: getGeoCountry(req),
      lang,
      // posts,
      // hasNextPage,
      // totalPosts: total,
    },
  };
};
